import axios from 'axios'
import CancellableRequest from '../../services/cancellable-request'

/**
 * api.get('/day', { params: { date: <date> } })
 * api.get('/week', { params: { start: <date>, end: <date> } })
 */
const instance = axios.create({
  baseURL: '/api/calendar',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-Token':
      process.env.NODE_ENV === 'test'
        ? null
        : document.querySelector('meta[name=csrf-token]').content
  }
})

const Api = new CancellableRequest(instance)
export default Api
